import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=f220028c&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=f220028c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f220028c",
  null
  
)

export default component.exports